import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")





export const detailedReport = async (params) => {
  console.log("detailedReport",params)
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "pollination-report/detailed-report",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const generateDetailedExcel = async (params) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}` }, params, responseType: 'blob' };
  try {
    const response = await axios.get(URL_BASE + "pollination-report/detailed-report-excel", config);
    const contentType = response.headers['content-type'];
    if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
      return response.data; 
    } else {   
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || "Error desconocido al generar el reporte.");
    }
  } catch (error) {
    return { error: error.message };
  }
};


export const duplicateReport = async (page,limit,startDate, endDate,farmId,sectionId,lotId,userId,lineId) => {
  const params = {startDate,endDate,farmId,lotId,page,limit ,sectionId,userId,lineId };
  console.log("detailedReport",params)
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "pollination-report/duplicate-report",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};






export default {
  detailedReport,
  generateDetailedExcel,
  duplicateReport
};
